export default __webpack_public_path__ + "static/about-banner-eb34974e8e1af299c464da51485914fb.jpg";